import template from './profile-menu.html';
import controller from './profile-menu.controller';
import './profile-menu.scss';

const ProfileMenuComponent = {
  template,
  controller,
};

export default ProfileMenuComponent;



// WEBPACK FOOTER //
// ./src/app/screens/engineer/components/profile-menu/index.js